import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "./__root.js";

export const statusRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/status",
  component: lazyRouteComponent(() => import("./status.page.js"), "StatusPage"),
});
